export default __webpack_public_path__ + "static/media/HEINEKEN_A5_2.0da2a708.png";